<template>
  <!-- Inner content -->
  <div class="inner-content">
    <section>
      <div class="container-fluid">
        <div class="row m-0">
          <div class="col-12">
            <div class="card">
              <div
                class="card-header card-header-primary d-flex flex-wrap align-items-center position-relative"
              >
                <div class="content-card-left">
                  <h4 class="card-title text-white">Companies</h4>
                </div>
                <div class="content-card-right ms-auto d-flex flex-wrap" v-if="user_role==='super_admin'">
                  <a
                    href="#addCompany"
                    data-bs-toggle="modal"
                    data-bs-target="#addCompany"
                    @click.prevent
                    class="btn btn-add d-flex flex-wrap align-items-center justify-content-center rounded-circle"
                  >
                    <i class="bi bi-plus-square-fill text-white"></i>
                  </a>

                  <a
                    href="#generateCompanyBalancesheet"
                    data-bs-toggle="modal"
                    data-bs-target="#generateCompanyBalancesheet"
                    @click.prevent
                    class="btn btn-add d-flex flex-wrap align-items-center justify-content-center rounded-circle me-1"
                  >
                    <i class="bi bi-file-earmark-spreadsheet-fill text-white"></i>
                  </a>

                  <a
                    href="#"
                    class="btn btn-add d-flex flex-wrap align-items-center justify-content-center rounded-circle me-1"
                    @click="counter_pdf_all"
                  >
                    <img
                      src="@/assets/images/pdf.png"
                      alt="pdf-image"
                      class="small-image white-image"
                    />
                  </a>

                  <router-link
                    to="/payment/company/add"
                    title="Add Payment via Company"
                    class="btn btn-add d-flex flex-wrap align-items-center justify-content-center rounded-circle me-1"
                  >
                    <i class="bi bi-cash-stack text-white"></i>
                  </router-link>
                </div>
              </div>
              <div class="card-body">
                <div class="header-content">
                  <div class="table-responsive mb-0">
                    <table id="my-table" class="custom-table shop-table">
                      <thead>
                        <tr>
                          <th class="text-capitalize">Id</th>
                          <th class="text-capitalize">Name</th>
                          <th class="text-capitalize">Type</th>
                          <th class="text-capitalize">Mobile</th>
                          <th class="text-capitalize">Address</th>
                          <th v-if="user_role==='super_admin'" class="text-capitalize text-center">Status</th>
                          <th class="text-capitalize text-center">actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="company in companies" :key="company.id">
                          <td>{{ company.id }}</td>
                          <td>{{ company.name }}</td>
                          <td>{{ company.type }}</td>
                          <td>{{ company.mobile }}</td>
                          <td>{{ company.address }}</td>
                          <td v-if="user_role==='super_admin'" class="text-center">
                            <span :class="['status-pill', company.status==='enable' ? 'is-active' : 'is-disabled']">
                              {{ company.status==='enable' ? 'Active' : 'Disabled' }}
                            </span>
                          </td>
                          <td class="action text-center">
                            <a v-if="user_role==='super_admin'"
                              href="#"
                              class="edit d-inline-block me-2"
                              data-bs-toggle="modal"
                              data-bs-target="#editCompany"
                              @click="edit_id = company.id"
                            >
                              <i class="bi bi-pencil-fill"></i>
                            </a>
                            <router-link
                              :to="`/companies/products/${company.id}`"
                              class="d-inline-block"
                            >
                              <i class="bi bi-cart-fill"></i>
                            </router-link>
                            <a
                              href="#"
                              class="edit d-inline-block text-center"
                              @click="updatePdfId(company)"
                            >
                              <img
                                src="@/assets/images/pdf.png"
                                alt="pdf-image"
                                class="small-image"
                              />
                            </a>
                            <router-link
                            v-if="user_role==='super_admin'" 
                            :to="{
                                path: `/companies/transactions/${company.id}`,
                                query: {
                                  companyName:`${company.name}`
                                }
                              }"
                              class="d-inline-block"
                              
                            >
                              <i v-if="user_role==='super_admin'" class="bi bi-credit-card-fill"></i>
                            </router-link>
                            <router-link
                              v-if="user_role==='super_admin'"
                              title="Claims / Commission"
                              :to="{
                                path: `/companies/claims/${company.id}`,
                                query: { companyName: `${company.name}` }
                              }"
                              class="d-inline-block ms-2"
                            >
                              <i class="bi bi-cash-coin"></i>
                            </router-link>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div
                class="card-footer card-footer custom-pagination d-flex flex-wrap justify-content-between m-0 px-4 pb-0 border-0 bg-transparent"
              >
                <p class="d-lg-inline-block table-data">
                  Showing
                  {{ total_count ? (current_page * entries_per_page - (entries_per_page - 1)) : 0 }}
                  to
                  {{ current_page * entries_per_page - (entries_per_page - companies.length) }}
                  of {{ total_count }} entries.
                </p>
                <div
                  class="d-inline-block ms-auto me-lg-0 me-md-0 me-sm-0 me-auto mb-lg-0 mb-md-0 mb-sm-0 mb-4 pagination-wrapper"
                >
                  <v-pagination
                    class="d-flex flex-lg-wrap flex-md-wrap flex-sm-wrap align-items-center p-0 m-0"
                    v-model="current_page"
                    :pages="total_pages"
                    :range-size="3"
                    @update:modelValue="loadData"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <company-add-modal @alert-event="showGrowl"></company-add-modal>
  <company-edit-modal
    @alert-event="showGrowl"
    :company_id="edit_id"
  ></company-edit-modal>
  <company-products-pdf
    :company_id="company_id"
    :count_number="count_number"
    :company_name="company_name"
  ></company-products-pdf>
  <generate-company-balancesheet-pdf></generate-company-balancesheet-pdf>
  <total-companies-pdf :counter_all="counter_all"></total-companies-pdf>
  <Alert
    v-if="growlMessage"
    :name="alert_m.name"
    :alertHeading="alert_m.heading"
    :alertDescription="alert_m.description"
  >
  </Alert>
</template>
<script>
import '@/assets/scss/pages/_billing.scss';
import companyServices from '@/services/CompanyServices';
import { ref, reactive, watch } from 'vue';
import CompanyAddModal from '@/components/modals/CompanyAddModal';
import CompanyEditModal from '@/components/modals/CompanyEditModal';
import VPagination from '@hennge/vue3-pagination';
import Alert from '@/components/alert';
import CompanyProductsPdf from '@/components/pdf/CompanyProductsPdf.vue';
import GenerateCompanyBalancesheetPdf from '@/components/modals/GenerateCompanyBalancesheetPdf.vue';
import TotalCompaniesPdf from '@/components/pdf/TotalCompaniesPdf.vue';
import { useStore } from 'vuex';

export default {
  name: 'Companies',
  components: {
    CompanyAddModal,
    CompanyEditModal,
    VPagination,
    Alert,
    CompanyProductsPdf,
    GenerateCompanyBalancesheetPdf,
    TotalCompaniesPdf,
  },
  setup() {
    const companies = ref([]);
    const count_number = ref(0);
    const company_id = ref(0);
    const company_name = ref('');
    const counter_all = ref(0);
    const store=useStore();
    const user_role=ref('');
    // Pagination state
    const current_page = ref(1);
    const total_pages = ref(0);
    const total_count = ref(0);
    const entries_per_page = ref(15);
    const updatePdfId = (cobj) => {
      company_id.value = cobj.id;
      count_number.value++;
      company_name.value = cobj.name;
    };

    const loadData = async () => {
      // Super admin manages companies, so it sees all (incl. disabled) via all=1.
      // The computer operator only sees active companies (default enabled-only).
      const isSuper = store.state.Auth?.user?.role?.name === 'super_admin';
      await companyServices
        .paginateCompanies(entries_per_page.value, isSuper, current_page.value)
        .then((response) => {
          companies.value = response.data.data;
          total_pages.value = response.data.last_page;
          current_page.value = response.data.current_page;
          total_count.value = response.data.total;
        });
    };

    const edit_id = ref(0);
    const alert_m = reactive({
      name: '',
      heading: '',
      description: '',
    });
    const growlMessage = ref(false);
    const showGrowl = (alertType) => {
      if (alertType == 'add') {
        alert_m.name = 'success';
        alert_m.description = 'Record Added Successfully';
      } else if (alertType == 'edit') {
        alert_m.name = 'success';
        alert_m.description = 'Record Updated Successfully';
        loadData(); // show the updated status
      } else {
        alert_m.name = 'danger';
        alert_m.description = 'No Record Found. Please try with valid data';
      }

      alert_m.heading = 'Company';
      growlMessage.value = true;
      setTimeout(() => {
        growlMessage.value = false;
      }, 5000);
    };
    const counter_pdf_all = () => {
      counter_all.value++;
    };

    // The layout fetches the authenticated user asynchronously, and a child's
    // onMounted runs before the parent's, so the role can still be empty when
    // this page first mounts. If we loaded now, isSuper would be false and the
    // super admin would briefly see only active companies. Instead, load once
    // the role is known, and reload if it resolves after mount.
    watch(
      () => store.state.Auth?.user?.role?.name,
      (roleName) => {
        if (roleName) {
          user_role.value = roleName;
          loadData();
        }
      },
      { immediate: true }
    );

    return {
      user_role,
      companies,
      loadData,
      current_page,
      total_pages,
      total_count,
      entries_per_page,
      showGrowl,
      alert_m,
      growlMessage,
      edit_id,
      company_id,
      count_number,
      updatePdfId,
      company_name,
      counter_pdf_all,
      counter_all,
    };
  },
};
</script>
